module.exports = __webpack_public_path__ + "img/introduce1.5f5ea0f4.png";